export const MAX_RESERVATION_DURATION_MONTHS = 12;

export const RESERVATION_CONSENT_CHECK_LIFETIME_MILLISECONDS = 24 * 60 * 60 * 1000;
